export default function PortableProjector(props: any) {
    return (
        <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_3296_4765)">
                <path
                    d="M39.332 19.5H41.582C42.8247 19.5 43.832 20.5074 43.832 21.75V33.75C43.832 34.9926 42.8247 36 41.582 36H7.08203C5.83939 36 4.83203 34.9926 4.83203 33.75V21.75C4.83203 20.5074 5.83939 19.5 7.08203 19.5H24.332"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15.332 36H9.33203V39H15.332V36Z" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M39.332 36H33.332V39H39.332V36Z" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M31.832 28.5C35.9743 28.5 39.332 25.1423 39.332 21C39.332 16.8577 35.9743 13.5 31.832 13.5C27.6898 13.5 24.332 16.8577 24.332 21C24.332 25.1423 27.6898 28.5 31.832 28.5Z"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeMiterlimit="10"
                />
                <path d="M21.332 12L22.9063 13.5743" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25.832 9L26.7704 11.0201" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M31.832 7.5V9.72778" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M42.4069 12L40.832 13.5743" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M37.2704 9L36.332 11.0201" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_3296_4765">
                    <rect width="48" height="48" fill="white" transform="translate(0.332031)" />
                </clipPath>
            </defs>
        </svg>
    );
}
